import Vue from "vue"
import Vuetify from "vuetify/lib"
import "@fortawesome/fontawesome-free/css/all.css"
import fr from "vuetify/es5/locale/fr"
import { comeFromManager } from "../helpers"

Vue.use(Vuetify)

let light

if (comeFromManager()) {
  light = {
    primary: "#3d485c",
    secondary: "#fe8000",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107",
  }
} else {
  light = {
    // primary: "#0070b0",
    primary: "#406098",
    secondary: "#fe8000",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107",
  }
}

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light,
    },
  },
  lang: {
    locales: { fr },
    current: "fr",
  },
  icons: {
    iconfont: "fa",
  },
})
